import styled from 'styled-components/macro'
import { transparentize } from 'polished'

import { Href } from 'components/ui'

export const Wrap = styled.footer`
  grid-area: Footer;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.color.elementBg};
  border-top: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
`

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    grid-template-columns: 30rem 1fr auto;
  `};
`

export const Copyright = styled.span`
  padding: 1.4rem 1.6rem;
  height: 100%;
  display: inline-flex;
  align-items: center;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.6;
  color: ${(props) => props.theme.color.textThird};
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    border-bottom: none;
  `};
`

export const Socials = styled.div`
  padding: 1rem 1.6rem;
  display: flex;
  align-items: center;
  gap: 2.4rem;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    border-bottom: none;
    border-left: 0.1rem solid ${props.theme.color.elementBorder};
    border-right: 0.1rem solid ${props.theme.color.elementBorder};
  `};
`

export const SocialsText = styled.span`
  display: inline-flex;
  align-items: center;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.25;
  color: ${(props) => props.theme.color.textThird};
`

export const SocialItem = styled(Href)`
  padding: 0.4rem;
  color: ${(props) => props.theme.color.textThird};
  border-radius: 1rem;
  &:hover:not([disabled]),
  &:focus:not([disabled]) {
    color: ${(props) => props.theme.color.textSecondary};
    background-color: ${(props) => transparentize(0.9, props.theme.color.elementBorder)};
  }
`

export const Version = styled.span`
  padding: 1.4rem 1.6rem;
  height: 100%;
  display: inline-flex;
  align-items: center;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.25;
  color: ${(props) => props.theme.color.textThird};
`
